import {Box, Card, Stack, styled} from '@mui/material';

export const StyledStack = styled(Stack)`
	gap: 32px;
	align-items: center;
	padding: 24px;
	min-height: 100vh;
	justify-content: center;

	${({theme}) => theme.breakpoints.up('md')} {
		flex-direction: row;
		gap: 24px;
	}
`;

export const StyledBox = styled(Box)`
	max-width: 214px;

	img {
		display: block;
		max-width: 100%;
	}

	${({theme}) => theme.breakpoints.up('md')} {
		max-width: 100%;
	}
`;

export const StyledCard = styled(Card)`
	padding: 16px;
	display: flex;
	flex-direction: column;
	gap: 16px;
	align-items: center;

	${({theme}) => theme.breakpoints.up('sm')} {
		gap: 24x;
		padding: 32px;
	}

	${({theme}) => theme.breakpoints.up('md')} {
		align-items: start;
	}
`;
